<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="生产基地">
              <global-select
                :value.sync="queryParams.manufactureBaseCode"
                selectType="select"
                :selectData="manufactureBaseCodeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织">
              <global-select
                :value.sync="queryParams.organizationCode"
                selectType="selectAssembleMultipleSearch"
                :default-active-first-option="defaultSelect"
                requestApi="/system/user/inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                :assembleLabel="true"
                searchParam="organizationName"
                :setParams="{ pageSize: 9999999 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="产线说明">
              <global-select
                :value.sync="queryParams.prodLineCode"
                selectType="selectMultiple"
                requestApi="/bom/bomProdLine/findList"
                :selectItem="{ value: 'prodLineCode', label: 'prodLineDesc' }"
                :setParams="{ organizationCode: queryParams.organizationCode }"
                sourseField="res"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料编码">
              <a-input v-model="queryParams.itemCode" allowClear />
              <!-- <global-select
                :value.sync="queryParams.itemCode"
                selectType="selectAssembleMultipleSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                searchParam="itemCode"
                :setParams="{ organizationCode: queryParams.organizationCode }"
              /> -->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="排线优先顺序" :labelCol="{ style: { width: '90px' } }">
              <a-input-number v-model="queryParams.linePriority" :min="0" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="产能类型">
              <global-select
                :value.sync="queryParams.capacityType"
                selectType="select"
                :selectData="capacityTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col> -->
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['bom:bomProdLineAssign:add']">新建</a-button>
      <a-button @click="importExcelHandleOpen('产线导入')" type="primary" v-hasPermi="['bom:bomProdLineAssign:import']">产线导入</a-button>
      <a-button @click="importExcelHandleOpen('工艺导入')" type="primary" v-hasPermi="['bom:bomProdLineAssign:importLine']">工艺导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['bom:bomProdLineAssign:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['bom:bomProdLineAssign:template']">产线模板</a-button>
      <a-button @click="importTemplateNew" v-hasPermi="['bom:bomProdLineAssign:templateDetail']">工艺模板</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="tableList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 3700}"
        >
          <div
            v-for="item in columns"
            :slot="item.dataIndex"
            slot-scope="text, record"
            :key="item.dataIndex"
          >
            <span v-if="item.dataIndex === 'operation'">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['bom:bomProdLineAssign:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" class="ml10" @click="$refs.gylxModalTable.show(record)">工艺路线</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <span v-else-if="item.type === 'select'">
              <span v-if="!isEdit || currentId !== record.id">{{ meaning(record, item.dataIndex) }}</span>
              <global-select
                v-if="isEdit && currentId === record.id"
                :value.sync="record[item.dataIndex]"
                :selectType="item.selectType ? item.selectType : 'select'"
                :requestApi="item.requestApi"
                :selectData="setArray(item.dataList)"
                :selectItem="{ value: item.value, label: item.label }"
                :searchParam="item.searchParam ? item.searchParam : ''"
                :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                :sourseField="item.sourseField ? item.sourseField : ''"
                :allowClear="false"
                size="small"
                :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              />
            </span>
            <span v-else-if="item.type === 'date'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-date-picker v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'input'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-input v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'inputNumber'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" size="small" @change="inputNumberChange(record, item.dataIndex)" />
            </span>
            <span v-else-if="item.type === 'switch'">
              <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record[item.dataIndex] === 'Y'" @change="statusOnChange(record, item.dataIndex)" />
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>{{ text }}</span>
          </div>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PRODUCT_PRODUCTION_LINE_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="prodLineCodeTitle">
            <i class="toRequired">*</i>产线编码
          </span>
          <span slot="itemCodeTitle">
            物料编码
          </span>
          <span slot="linePriorityTitle">
            <i class="toRequired">*</i>排线优先顺序
          </span>
          <span slot="unitCapacityTitle">
            <i class="toRequired">*</i>产能(套/时)
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['bom:bomProdLineAssign:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== text.record.id" class="ml10" @click="$refs.gylxModalTable.show(text.record)">工艺路线</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.dataIndex === 'itemId'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record.itemCode"
                  selectType="selectAssembleSearch"
                  requestApi="/mes/mesDiscreteJobs/assemblyBox"
                  :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                  searchParam="itemCode"
                  @change="(val, list)=>{handleSelectedItemId(val, list, text.record)}"
                  :dropdown-match-select-width="false"
                />
              </span>

              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :setParams="item.setParams ? setParamsHandle(text.record, item.dataIndex) : null"
                  :sourseField="item.sourseField ? item.sourseField : ''"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                />
              </span>
              <span v-else-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-date-picker v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'input'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" :min="0" size="small" @change="inputNumberChange(text.record, item.dataIndex)" />
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record[item.dataIndex] === 'Y'" @change="statusOnChange(text.record, item.dataIndex)" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>

        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <product-production-line-add
          ref="createModal"
          :inventOrg="inventOrg"
          :workshopCodeList="workshopCodeList"
          :manufactureBaseCodeList="manufactureBaseCodeList"
          @handle-success="handleOk"
        />
        <product-production-line-list ref="gylxModalTable" @handle-success="handleOk" />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiBomProdLineAssignUpdate, apiBomWorkshopFindList, apiBomProdLineAssignList } from '@/api/mes/basedata/productProductionLine'
import ProductProductionLineAdd from './components/product-production-line-add'
import ProductProductionLineList from './components/product-production-line-list'
import Cookies from 'js-cookie';
import cacheSearch from '@/mixins/cacheSearch'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  name: 'ProductProductionLine',
  components: {
    ProductProductionLineAdd,
    ProductProductionLineList
  },
  mixins: [cacheSearch],
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
        // 表格配置
        tableProps: {
        requestApi: generateLsTableResData(apiBomProdLineAssignList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: ""
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: false,
        pageUrl: '/bom/bomProdLineAssign/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        manufactureBaseCode: undefined,
        organizationCode: undefined,
        prodLineCode: undefined,
        itemCode: undefined,
        linePriority: undefined,
        capacityType: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '生产基地',
          dataIndex: 'manufactureBaseCode',
          align: 'center',
          stickyFixed: 'left',
          width: 170,
          scopedSlots: { customRender: 'manufactureBaseCode' },
          type: "select",
          dataList: 'manufactureBaseCodeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '加工组织',
          width: 170,
          stickyFixed: 'left',
          dataIndex: 'organizationName',
          align: 'center'
          // width: 170,
          // scopedSlots: { customRender: 'organizationCode' },
          // type: "select",
          // selectType: "selectAssemble",
          // assembleLabel: true,
          // dataList: 'inventOrg',
          // value: 'realValue',
          // label: 'label'
        },
        {
          title: '供应商',
          width: 250,
          ellipsis: true,
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '供应商简称',
          width: 150,
          ellipsis: true,
          dataIndex: 'supplierCode',
          align: 'center'
        },
        {
          customTitle: '产线编码',
          dataIndex: 'prodLineId',
          align: 'center',
          width: 170,
          scopedSlots: { customRender: 'prodLineId', title: "prodLineCodeTitle" },
          type: "select",
          setParams: true,
          sourseField: "res",
          requestApi: "/bom/bomProdLine/findList",
          value: 'id',
          label: 'prodLineCode'
        },
        {
          title: '产线说明',
          width: 120,
          dataIndex: 'prodLineDesc',
          align: 'center'
        },
        {
          title: '标准总人数',
          width: 120,
          dataIndex: 'totalNumOfPeople',
          align: 'center'
          // scopedSlots: { customRender: 'totalNumOfPeople' },
          // type: 'inputNumber'
        },
        {
          title: '总人数配置',
          width: 120,
          dataIndex: 'personnelAllocation',
          align: 'center'
          // scopedSlots: { customRender: 'personnelAllocation' },
          // type: 'input'
        },
        {
          title: '工厂级别标准参考产品',
          dataIndex: 'refProductFactory',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'refProductFactory' },
          type: 'switch'
        },
        {
          title: '产线级别标准参考产品',
          dataIndex: 'refProductLine',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'refProductLine' },
          type: 'switch'
        },
        {
          title: '人员级别标准参考产品',
          dataIndex: 'refProductPersonnel',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'refProductPersonnel' },
          type: 'switch'
        },
        {
          customTitle: '物料编码',
          dataIndex: 'itemId',
          align: 'center',
          width: 170,
          scopedSlots: { customRender: 'itemId', title: "itemCodeTitle" },
          type: "select",
          selectType: "selectAssembleSearch",
          requestApi: "/mes/mesDiscreteJobs/assemblyBox",
          searchParam: "itemCode",
          value: 'selectedValue',
          label: 'bringOutDataOne'
        },
        // {
        //   title: '项目组',
        //   dataIndex: 'projectTeam',
        //   align: 'center'
        // },
        // {
        //   title: '销售类目',
        //   dataIndex: 'salesCategory',
        //   align: 'center'
        // },
        {
          title: '主型号',
          width: 120,
          dataIndex: 'foldNumber',
          align: 'center'
        },
        {
          title: '物料名称',
          width: 250,
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '规格描述',
          width: 120,
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          width: 120,
          dataIndex: 'primaryUom',
          align: 'center'
        },
        {
          title: '商品类目',
          width: 120,
          dataIndex: 'materialDir',
          align: 'center'
        },
        {
          title: '二级分类',
          width: 120,
          dataIndex: 'ejflName',
          align: 'center'
        },
        {
          title: '商品类别',
          width: 120,
          dataIndex: 'productCategory',
          align: 'center'
        },
        {
          title: '工艺分层',
          width: 120,
          dataIndex: 'techniqueStructure',
          align: 'center'
        },
        {
          title: '产品族',
          width: 120,
          dataIndex: 'productGroup',
          align: 'center'
        },
        {
          title: '瓶颈工序CT（套/分钟）',
          dataIndex: 'maxOperation',
          align: 'center',
          // scopedSlots: { customRender: 'maxOperation' },
          // type: 'inputNumber',
          width: 190
        },
        {
          // title: '排线优先顺序',
          customTitle: '排线优先顺序',
          width: 120,
          dataIndex: 'linePriority',
          align: 'center',
          scopedSlots: { customRender: 'linePriority', title: 'linePriorityTitle' },
          type: 'inputNumber'
        },
        {
          title: '产线等价系数',
          width: 120,
          dataIndex: 'coefficient',
          align: 'center',
          scopedSlots: { customRender: 'coefficient' },
          type: 'inputNumber'
        },
        // {
        //   title: '产能类型',
        //   dataIndex: 'capacityType',
        //   align: 'center',
        //   width: 170,
        //   scopedSlots: { customRender: 'capacityType' },
        //   type: "select",
        //   dataList: 'capacityTypeList',
        //   value: 'lookupCode',
        //   label: 'lookupValue'
        // },
        // {
        //   title: '产能效率(套/分钟)',
        //   dataIndex: 'efficiency',
        //   align: 'center',
        //   width: 190,
        //   scopedSlots: { customRender: 'efficiency' },
        //   type: 'inputNumber'
        // },
        {
          customTitle: '产能(套/时)',
          width: 120,
          dataIndex: 'unitCapacity',
          align: 'center',
          scopedSlots: { customRender: 'unitCapacity', title: 'unitCapacityTitle' },
          type: 'inputNumber'
        },
        {
          title: '状态',
          width: 120,
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' },
          type: 'switch'
        },
        {
          title: '操作',
          width: 130,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      workshopCodeList: [], // 车间编码
      manufactureBaseCodeList: [], // 生产基地
      capacityTypeList: [] // 产能类型
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.getBomWorkshopFindList()
    this.getLookupList('MES_MANUFACTURE_BASE', 'manufactureBaseCodeList')
    this.getLookupList('MES_CAPACITY_TYPE', 'capacityTypeList')
    // 处理缓存逻辑
    this.getCacheNoRef('organizationCode')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.setSearchCache(this.queryParams) // 设置缓存
      this.$refs.dataTable.getData();
      this.isEdit = false
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.organizationCode) {
        this.$message.warning('加工组织 不能为空')
        return
      }
      if (!record.prodLineId) {
        this.$message.warning('产线编码 不能为空')
        return
      }
      // if (!record.itemId) {
      //   this.$message.warning('物料编码 不能为空')
      //   return
      // }
      if (!record.linePriority) {
        this.$message.warning('排线优先顺序需大于0')
        return
      }
      if ((record.coefficient || record.coefficient === 0) && Number(record.coefficient) <= 0) {
        this.$message.warning('产线等价系数需大于0')
        return
      }
      if (!record.unitCapacity || Number(record.unitCapacity) <= 0) {
        this.$message.warning('产能(套/时) 不能为空且需大于0')
        return
      }
      apiBomProdLineAssignUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.onSearch()
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        manufactureBaseCode: undefined,
        organizationCode: undefined,
        prodLineCode: undefined,
        itemCode: undefined,
        linePriority: undefined,
        capacityType: undefined
      }
      this.handleQuery()
    },
    statusOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "prodLineId") {
        return { organizationCode: record.organizationCode }
      }
    },
    meaning (record, dataIndex) {
      if (dataIndex === "manufactureBaseCode") {
        return record.manufactureBaseName
      }
      if (dataIndex === "organizationCode") {
        return record.organizationName
      }
      if (dataIndex === "prodLineId") {
        return record.prodLineCode
      }
      if (dataIndex === "itemId") {
        return record.itemCode
      }
      return record[dataIndex]
    },
    setArray (arr) {
      return this[arr]
    },
    inputNumberChange (record, dataIndex) {
      // if (dataIndex === "maxOperation") {
      //   record.unitCapacity = this.$parseFloatToFixed(60 / Number(record.maxOperation), 6)
      // }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (val) {
      if (val === "产线导入") {
        this.upload.url = process.env.VUE_APP_API_BASE_URL + '/bom/bomProdLineAssign/import'
      }
      if (val === "工艺导入") {
        this.upload.url = process.env.VUE_APP_API_BASE_URL + '/bom/bomProdLineAssign/importLine'
      }
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('bom/bomProdLineAssign/template', {
        ...this.queryParams
      }, `产品产线导入模板_${new Date().getTime()}.xlsx`)
    },
    /** 下载模板操作 */
    importTemplateNew () {
      this.download('bom/bomProdLineAssign/templateDetail', {
        ...this.queryParams
      }, `产品工艺路线导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('bom/bomProdLineAssign/export', {
        ...this.queryParams
      }, `产品产线_${new Date().getTime()}.xlsx`)
    },
    // 车间编码
    getBomWorkshopFindList () {
      apiBomWorkshopFindList().then(res => {
        if (res && res.length > 0) {
          this.workshopCodeList = res
        }
      })
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    handleSelectedItemId (val, list, record) {
      if(!val) {
        record.itemId = ''
        return false
      }
      const selectItem = list.find(item => {
        return item.selectedValue === val
      })
      record.itemId = selectItem.realValue
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  /deep/.ant-select{
    width: 150px;
  }
}
.table-page-search-wrapper{
  /deep/.ant-input-number{
    width: 100% !important;
  }
}
</style>
